import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SessionBoundary({ children }) {
  const { sessionExpired, acknowledgeSessionExpiry } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (sessionExpired && location.pathname === '/login') acknowledgeSessionExpiry();
  }, [sessionExpired, location.pathname, acknowledgeSessionExpiry]);

  if (sessionExpired && location.pathname !== '/login') {
    return <Navigate to="/login" replace state={{
      sessionExpired: true,
      from: `${location.pathname}${location.search}${location.hash}`,
    }} />;
  }

  return children;
}
